<template>
  <div class="account-details">
    <h2 class="account-details__title">
      Account Details
    </h2>

    <div class="account-details__container">
      <div class="account-details__info">
        <div
          v-for="(detail, i) in detailsInfo"
          :key="`${detail.title}-${i}`"
          class="account-details__detail">
          <span class="account-details__detail-title">{{ detail.title }}:</span>

          <span>{{ detail.value }}</span>
        </div>
      </div>

      <div class="account-details__description">
        {{ description }}
      </div>

      <div class="account-details__footer">
        <img
          data-src="/images/icons/protected.svg"
          class="lazyload account-details__footer-image"
          width="32"
          height="32"
          alt="SkyCoach Guarantee">

        <span class="account-details__footer-title">SkyCoach Guarantee</span>

        <span class="account-details__footer-text">Your purchases are protected</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AccountDetailsCard',

  props: {
    detailsInfo: {
      type: Array,
      default: () => [],
    },

    description: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState(['userDevice']),
  },
};
</script>

<style scoped lang="scss">
 .account-details {
   display: flex;
   flex-direction: column;
   padding: 24px;
   background-color: rgba($color--basic-black, 0.8);
   border: 1px solid $color--basic-menu;
   border-radius: 16px;
   width: 100%;
 }

 .account-details__title {
   font-size: 19px;
   font-weight: 500;
   margin-bottom: 16px;
 }

 .account-details__container {
   display: grid;
   grid-auto-flow: row;
   grid-template-columns: auto;
 }

 .account-details__info {
   display: flex;
   flex-wrap: wrap;
 }

 .account-details__detail {
   width: 20%;
   display: flex;
   flex-direction: column;
   gap: 8px;
   border-bottom: 1px solid $color--basic-menu;
   padding: 12px 0;
   font-size: 13px;
   line-height: 16px;
   font-weight: 500;
   color: $color--basic-white;
 }

 .account-details__detail-title {
   color: $color--basic-dark-gray;
 }

 .account-details__image {
   max-width: 150px;
 }

 .account-details__description {
   margin-top: 8px;
   font-size: 15px;
   font-weight: 400;
   white-space: pre-line;
 }

 .account-details__footer {
   display: grid;
   grid-template-columns: 32px 1fr;
   grid-template-rows: repeat(auto-fill, minmax(20px, 1fr));
   grid-column-gap: 8px;
   margin-top: 24px;
 }

 .account-details__footer-title {
   font-size: 12px;
   grid-column: 2;
   grid-row: 1;
 }

 .account-details__footer-text {
   font-size: 12px;
   grid-column: 2;
   grid-row: 2;
   color: $color--basic-light-gray;
 }

 .account-details__footer-image {
   grid-row: span 2;
 }

 @media screen and #{$screen-less-than-1366} {
   .account-details__image {
     margin-bottom: 16px;
   }

   .account-details__container {
     grid-auto-flow: row;
     grid-template-columns: auto;
   }

   .account-details__detail {
     width: 50%;
   }
 }
</style>
